// LLM generated - Model Claude 4 Sonnet
import { IconMessageCircleOff } from '@tabler/icons-react';
import useTranslation from 'next-translate/useTranslation';

import { EmptyState } from '../../../EmptyState';

function ChatDisabled() {
  const { t } = useTranslation('chat');

  return (
    <EmptyState
      size="md"
      icon={<IconMessageCircleOff size={40} />}
      title={t('emptyStates.chatDisabled.title')}
      description={t('emptyStates.chatDisabled.description')}
      c="gray2.3"
    />
  );
}

export default ChatDisabled;
